"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IconSvg_1 = require("./IconSvg");
exports.default = IconSvg_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/IconSvg/index.js
// module id = 132
// module chunks = 8